import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const prodConfig = {
  apiKey: 'AIzaSyDS8LsDZsxGByLgzvD_3ZCT7OPKefoyb7k',
  authDomain: 'hundehall.firebaseapp.com',
  projectId: 'hundehall',
  storageBucket: 'hundehall.appspot.com',
  messagingSenderId: '856359758681',
  appId: '1:856359758681:web:69b1fcef96b8a0e0ab3a48',
  measurementId: 'G-6JW76H316S'
}

const devConfig = {
  apiKey: 'AIzaSyD1inE2mH0Npahx0lp8eAe7sKpDTn4W0Ho',
  authDomain: 'hundehall-dev.firebaseapp.com',
  projectId: 'hundehall-dev',
  storageBucket: 'hundehall-dev.appspot.com',
  messagingSenderId: '835903036475',
  appId: '1:835903036475:web:5378269a74097afac0d01e',
  measurementId: 'G-RBYMY15L1R'
}

const config = import.meta.env.MODE === 'production' ? prodConfig : devConfig

export const app = initializeApp(config)
export const auth = getAuth(app)
export const db = getFirestore(app)
